import { NodeProps } from '@xyflow/react'
import React from 'react'

import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { BaseNode, nodePropsAreEqual } from './BaseNode'

export interface StartNodeProps extends NodeProps {
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void

  showDeleteButton?: boolean
}

const StartNodeComponent: React.FC<StartNodeProps> = ({
  id,
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const t = useSwitchboardT()
  const label = text(t, 'switchboard.nodeLabels.start', 'START')
  return (
    <BaseNode
      badgeColor="blue"
      label={label}
      targetHandlePosition={null}
      compact
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
      borderRadius="xl"
      headerPaddingX={6}
      headerPaddingY={4}
      customBadgeBg="transparent"
      customBadgeColor="fg.default"
      headerJustifyContent="center"
    />
  )
}

export const StartNode = React.memo(StartNodeComponent, nodePropsAreEqual)
